import { render, staticRenderFns } from "./SpHeaderMenu.vue?vue&type=template&id=33e8f1d7&scoped=true&"
import script from "./SpHeaderMenu.vue?vue&type=script&lang=ts&"
export * from "./SpHeaderMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SpHeaderMenu.vue?vue&type=style&index=0&id=33e8f1d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8f1d7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/codebuild/output/src2039654861/src/threease_lp/components/shared/Base/BaseButton.vue').default})
